import '@terra-js/web-bridge';
import PaymentKit, { PaymentRequestBuilder } from '@terra-js/payment-kit';
import { MainMethodType } from '@terra-js/payment-kit/dist/constansts';
import TerraKit from '@terra-js/terra-kit';
import ShopFrontKit, { ScreenConfig } from '@terra-js/shop-front-kit';
import type { OrderService } from '@teko/order';

const waitForPaymentStatus = 'WAITING_FOR_PAYMENT_CONFIRMATION';
interface BasePayParams {
  customerProfileId: string;
  orderService: OrderService;
}

interface OrderDetail {
  code: string;
  id: string;
  remainPayment: number;
}

interface PayForOrderParams extends BasePayParams {
  order: OrderDetail;
}
interface PayParams extends BasePayParams {
  orderCode: string;
  orderId: string;
  amount: number;
}

const terraHelper = {
  isAvailable: TerraKit.isAvailable,
  handleBackOr: async (callback?: () => void) => {
    if (TerraKit.isAvailable()) {
      const shouldHandleBack = await ShopFrontKit.shouldHandleBack();
      if (shouldHandleBack) {
        ShopFrontKit.handleBack();
      } else {
        callback?.();
      }
    } else {
      callback();
    }
  },
  getScreenConfig: (): Promise<ScreenConfig | undefined> => {
    if (TerraKit.isAvailable()) {
      return ShopFrontKit.getScreenConfig();
    } else {
      return Promise.resolve(undefined);
    }
  },
  finish: () => TerraKit.finish(),
  payForOrder: ({
    order,
    customerProfileId,
    orderService,
  }: PayForOrderParams): Promise<void> => {
    return terraHelper.pay({
      orderCode: order.code,
      orderId: order.id,
      amount: order.remainPayment,
      customerProfileId,
      orderService,
    });
  },
  pay: ({
    orderCode,
    orderId,
    amount,
    customerProfileId,
    orderService,
  }: PayParams): Promise<void> => {
    if (TerraKit.isAvailable()) {
      const paymentRequestBuilder = new PaymentRequestBuilder();
      paymentRequestBuilder
        .setOrder({
          orderCode: orderCode,
          orderAmount: amount,
        })
        .setPaymentMethods({
          mainMethod: {
            method: MainMethodType.All,
            amount,
          },
          totalAmount: amount,
        })
        .setOptions({
          shouldShowPaymentResultScreen: true,
        });
      return PaymentKit.payForOrder(paymentRequestBuilder.build()).then(
        (result) => {
          switch (result.resultCode) {
            case 'succeeded':
              window.location.href = `/account/orders/${orderId}`;
              break;
            case 'canceled':
            case 'failed':
              orderService
                .getOrder({ orderId, customerId: customerProfileId })
                .then((order) => {
                  if (order.status === waitForPaymentStatus) {
                    window.location.href = `/confirm-payment/${orderId}`;
                  } else {
                    window.location.href = `/account/orders?tab=WAIT_PAYMENT`;
                  }
                })
                .catch(() => {
                  // this is a fallback in case the order is not synced with cov
                  window.location.href = `/account/orders?tab=WAIT_PAYMENT`;
                });
              break;
          }
        },
      );
    }
    return Promise.resolve();
  },
};

export default terraHelper;
